import React from "react";
import { Interview } from "components";
import { interviewGloria } from "data/interview-gloria";
import * as S from "./styles";

export const Slide22: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Title>entrevista | gloria groove</S.Title>
        <Interview questions={interviewGloria} />
      </S.Wrapper>
    </S.Container>
  );
};
